export interface Toast {
	header?: string,
	message: string,
  delay?: number
  type: Type
}

export enum Type {
  Info = "bg-primary text-light",
  Success = "bg-success text-light",
  Error = "bg-danger text-light",
  Warning = "bg-warning text-light"
}
